import { useState } from "react";
import { BarChartOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "../Dokument/DokumentListKorisnik.css";
import "./AnketaListKorisnik.css";
import { formatDateTime } from "../../utils/formatDateTime";

function AnketaListKorisnik({ ankete }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentAnkete = ankete.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(ankete.length / itemsPerPage);

  const handleClickAnketa = async (anketaId) => {
    navigate(`/ankete/${anketaId}`);
  };

  const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
  return (
    <div className="documents-list-container-korisnik">
       {currentAnkete.length === 0 ? (
        <p style={{ textAlign: "center", color: "#c8c3a7" }}>
          Nema dostupnih anketa.
        </p>
      ) : (
      currentAnkete.map((anketa, index) => {
        const backgroundColor = colors[index % colors.length];
        return (
          <div
            key={anketa.id}
            className="dokument-kartica"
            style={{ backgroundColor }}
            onClick={() => handleClickAnketa(anketa.id, anketa.saglasnostId)}
          >
            <div className="kartica-sadrzaj">
              <div className="kartica-ikona">
                <BarChartOutlined />
              </div>

              <div className="kartica-tekst">
                <div className="kartica-zaglavlje">
                  <h3 className="kartica-naslov">{anketa.naziv}</h3>
                  {formatDateTime(anketa.datumVazenja) !== "N/A" && (
                    <p className="kartica-datum">
                      Važi do: {formatDateTime(anketa.datumVazenja)}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      }))}

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prethodna
          </button>

          <span>
            Stranica {currentPage} od {totalPages}
          </span>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Sljedeća
          </button>
        </div>
      )}
    </div>
  );
}

export default AnketaListKorisnik;
